module.exports = __webpack_public_path__ + "img/vscode.2c2b59fd.svg";